module.exports = __webpack_public_path__ + "awardsn-fe3fa4c4.webp";